import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_toggle_menu_button"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer symbol symbol-30px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "border border-success btn btn-icon btn-bg-wash btn-active-color-primary btn-sm me-1",
    title: "Application Switcher"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-th text-success" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTToggleLink = _resolveComponent("KTToggleLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_KTToggleLink)
    ])
  ]))
}